import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'src/app/shared/shared.module';
import { RegisterSelectorComponent } from './components/register-selector.component';
import { TimeSelectorComponent } from './components/time-selector.component';
import { RegistriComponent } from './registri.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CalendarModule,
    ButtonModule,
    SelectButtonModule,
    DropdownModule,
    TableModule,
    SharedModule
  ],
  declarations: [
    RegistriComponent,
    RegisterSelectorComponent,
    TimeSelectorComponent
  ]
})
export class RegistriModule { }
